import React, { useEffect, useRef } from "react";
// import { gsap } from 'gsap';
import { HiOutlineShoppingBag } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { Buttons } from "../Buttons";
import { server } from "../../utilis/constant";
import { FaHeart } from "react-icons/fa";
import { Col } from "antd";
function ProductCard({ products }) {
  const cardRef = useRef(null);
  const heartRef = useRef(null);
  const eyeRef = useRef(null);

  const navigate = useNavigate();
  const handleGoHome = () => {
    navigate("/product_description");
  };

  //   // Scroll animation
  //   useEffect(() => {
  //     gsap.fromTo(
  //       cardRef.current,
  //       { opacity: 0, y: 50 },
  //       {
  //         opacity: 1,
  //         y: 0,
  //         duration: 1,
  //         ease: 'power3.out',
  //         scrollTrigger: {
  //           trigger: cardRef.current,
  //           start: 'top 80%',
  //           toggleActions: 'play none none none',
  //         },
  //       }
  //     );
  //   }, []);

  //   // Icon hover animations
  //   const handleIconHover = (ref) => {
  //     gsap.to(ref.current, {
  //       scale: 1.3,
  //       duration: 0.3,
  //       ease: 'power2.out',
  //     });
  //   };

  //   const handleIconLeave = (ref) => {
  //     gsap.to(ref.current, {
  //       scale: 1,
  //       duration: 0.3,
  //       ease: 'power2.out',
  //     });
  //   };

  return (
    <div className="product-card group h-full bg-white rounded-3xl border border-gray-200 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500 flex flex-col relative">
      {/* Image Section */}
      <div className="relative aspect-[4/3.2] bg-[#F8F4ED] ">
        <img
          onClick={() => navigate(`/product_description/${products._id}`)}
          src={`${server}/${products.image || products.variants?.[0]?.image}`}
          alt={products.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />

        {/* New Badge */}
        {products.tags.includes("New Arrivals") && (
          <div className="absolute top-5 left-5 bg-gradient-to-br from-[#D4AF37] to-[#B8972E] text-black text-xs font-bold px-5 py-1.5 rounded-full shadow-md">
            NEW
          </div>
        )}

        {/* Heart Icon */}
        <div className="absolute top-5 right-5 w-9 h-9 bg-white rounded-2xl shadow-md flex items-center justify-center cursor-pointer transition-all duration-300 group-hover:scale-110 active:scale-90">
          <FaHeart className="text-gray-400 text-2xl transition-all duration-300 group-hover:text-red-500" />
        </div>
      </div>

      {/* Content - Tight Spacing */}
      <div className="px-6 pt-5 pb-6 flex flex-col flex-1 text-center">
        <h3 className="font-semibold text-lg leading-tight text-black line-clamp-2 mb-3 min-h-[52px]">
          {products.title}
        </h3>

        <div className="flex justify-center gap-1 text-[#D4AF37] text-2xl mb-4">
          {"★".repeat(Math.floor(products.rating || 4))}
          {"☆".repeat(5 - Math.floor(products.rating || 4))}
        </div>

        {/* Price + Add to Cart */}
        <div className="mt-auto flex items-center justify-between">
          <p className="text-3xl font-bold text-black tracking-tight">
            ${products.variants[0].price}
          </p>

          <button className="px-5 py-2.5 bg-black text-white text-sm font-medium rounded-2xl opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-500 hover:bg-[#D4AF37] hover:text-black">
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
